import {FC} from 'react';
import {Box} from '@chakra-ui/react';
import {Badge, TBadgeVariant} from '@kcast-fe/ui-kit';
import {capitalizeFirstLetter, EDocumentApiStatus, hasValue, IDocumentInfo} from '@kcast-fe/core';

const STATUS_BADGE_VARIANT: Record<EDocumentApiStatus, TBadgeVariant> = {
  [EDocumentApiStatus.Accepted]: 'neutral',
  [EDocumentApiStatus.Stored]: 'neutral',
  [EDocumentApiStatus.Processing]: 'neutral',
  [EDocumentApiStatus.Failed]: 'error',
  [EDocumentApiStatus.Degraded]: 'info',
  [EDocumentApiStatus.Ready]: 'success'
};

interface IProps {
  item: IDocumentInfo;
}

const StatusCellFC: FC<IProps> = ({item}) => {
  return (
    <Box>
      {hasValue(item.api_status) ? (
        <Badge variant={STATUS_BADGE_VARIANT[item.api_status]}>
          {capitalizeFirstLetter(item.api_status)}
        </Badge>
      ) : (
        '—'
      )}
    </Box>
  );
};

export const StatusCell = StatusCellFC;
